export default function createPeerConnection() {
  return new RTCPeerConnection({
    iceServers: [
      { urls: "stun:stun2.l.google.com:19302" },
      {
        urls: "turn:turn.tappytaps.com?transport=tcp",
        username: "dogmonitor",
        credential: "987654"
      }
    ]
    // stun:stun1.l.google.com:19302
    // stun:stun2.l.google.com:19302
    // stun:stun3.l.google.com:19302
    // stun:stun4.l.google.com:19302
  });
}
